export default __webpack_public_path__ + "static/media/flag-mayotte.4ce47593.svg";